import script from "./MessageFilelist.vue?vue&type=script&lang=ts&setup=true"
export * from "./MessageFilelist.vue?vue&type=script&lang=ts&setup=true"

import "./MessageFilelist.vue?vue&type=style&index=0&id=41ffdc58&scoped=true&lang=scss"

import exportComponent from "/var/build/production/buyers-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41ffdc58"]])

export default __exports__